import React from 'react';
import type { MouseEvent as ReactMouseEvent } from 'react';
import { ProductVideoItemProps } from '../interfaces';
import { getPlayableVideoUrl } from './imageForProductById.utils';
import './ProductVideoItem.scss';

const handleVideoClick = (event: ReactMouseEvent<HTMLVideoElement>) => {
  const video = event.currentTarget;

  if (video.paused) {
    void video.play();
  } else {
    video.pause();
  }
};

const handleVideoRewind = (event: ReactMouseEvent<HTMLButtonElement>, videoId: string) => {
  event.stopPropagation();
  const video = document.getElementById(videoId) as HTMLVideoElement | null;

  if (!video) return;

  video.currentTime = 0;
  void video.play();
};

const ProductVideoItem: React.FC<ProductVideoItemProps> = ({ media }) => {
  const videoId = `product-video-${media.id}`;

  return (
    <div className="image-wrapper media-video-wrapper">
      <video
        id={videoId}
        src={getPlayableVideoUrl(media.url)}
        className="product-animation-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        onClick={handleVideoClick}
        onDoubleClick={(event) => {
          event.currentTarget.currentTime = 0;
          void event.currentTarget.play();
        }}
      />
      <button
        type="button"
        className="product-animation-rewind"
        onClick={(event) => handleVideoRewind(event, videoId)}
        aria-label="Restart animation"
      >
        Replay
      </button>
    </div>
  );
};

export default ProductVideoItem;
